export const costs = [
  'Prepari ogni lezione sulle rinnovabili da zero, cercando materiale sparso su internet',
  "Spiegare come il sole, il vento e l'acqua diventano elettricità senza schemi chiari è difficile",
  'Non hai attività, esperimenti e verifiche pronte da usare in classe',
  'Ti manca tempo per programmare unità didattiche complete e coerenti',
];
